(function () {
  let lastTouchHandledAt = 0;

  function getPopup() {
    return document.querySelector('cart-popup');
  }

  async function loadPopup() {
    const popup = getPopup();
    if (!popup) return null;

    if (customElements.get('cart-popup')) return popup;

    await customElements.whenDefined('cart-popup');
    return getPopup();
  }

  function getCartLink(event) {
    const target = event.target;
    if (!(target instanceof Element)) return null;

    return target.closest('[data-cart-popup-trigger], #cart-icon-bubble');
  }

  function getSectionsToRender() {
    return ['cart-popup', 'cart-icon-bubble'];
  }

  async function renderResponse(parsedState, options = {}) {
    const popup = await loadPopup();
    if (!popup) return false;

    const shouldOpen = options.shouldOpen !== false;

    if (options.trigger && typeof popup.setActiveElement === 'function') {
      popup.setActiveElement(options.trigger);
    }

    if (typeof popup.renderNormalizedContents === 'function') {
      return popup.renderNormalizedContents(parsedState, shouldOpen);
    }

    if (parsedState?.sections && typeof popup.renderContents === 'function') {
      popup.renderContents(parsedState, shouldOpen);
      return true;
    }

    if (typeof popup.refresh === 'function') {
      await popup.refresh(shouldOpen);
      return true;
    }

    if (shouldOpen && typeof popup.open === 'function') {
      popup.open(options.trigger);
    }

    return true;
  }

  function openCartPopup(cartLink) {
    cartLink.setAttribute('aria-busy', 'true');

    renderResponse(null, { trigger: cartLink })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        cartLink.removeAttribute('aria-busy');
      });
  }

  function interceptCartOpen(event) {
    const cartLink = getCartLink(event);
    if (!cartLink) return;

    if (event.type === 'click' && Date.now() - lastTouchHandledAt < 700) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (event.type === 'touchend') {
      lastTouchHandledAt = Date.now();
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    openCartPopup(cartLink);
  }

  function prepareCartIcon() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink || cartLink.dataset.cartPopupLoaderBound === 'true') return;

    cartLink.dataset.cartPopupLoaderBound = 'true';
    cartLink.dataset.cartPopupBound = 'true';
    cartLink.href = '#CartPopup';
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('keydown', (event) => {
      const key = (event.code || event.key || '').toUpperCase();
      if (key !== 'SPACE' && key !== ' ') return;

      event.preventDefault();
      openCartPopup(cartLink);
    });
  }

  document.addEventListener('touchend', interceptCartOpen, { capture: true, passive: false });
  document.addEventListener('click', interceptCartOpen, true);

  window.CartPopupLoader = {
    getSectionsToRender,
    load: loadPopup,
    open: openCartPopup,
    renderResponse,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareCartIcon, { once: true });
  } else {
    prepareCartIcon();
  }

  document.addEventListener('shopify:section:load', prepareCartIcon);
})();
